import ApiService from "../../util/ApiService";
import {
  GET_HOWE_WIDGET_INFO_SUCCESS,
  GET_HOWE_WIDGET_INFO_ERROR,
} from "../../constants/action-types";
import { errorHandler } from "./errorHandler";

const widgetErrorHandler = errorHandler("CEHomeCallout");

export const fetchHomeWidgetInfo = async (dispatch) => {
  try {
    const response = await ApiService.get("/v1/cme-callout-info");
    dispatch({
      type: GET_HOWE_WIDGET_INFO_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: GET_HOWE_WIDGET_INFO_ERROR });
    widgetErrorHandler(dispatch, error);
  }
};
